module.exports = __webpack_public_path__ + "img/netent.14561e32.png";